import { faUserGroup } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar } from "antd";
import React from "react";
import FollowButton from "../FollowButton/FollowButton";

function ToolTipTitle({ avatar, name, followers, isFollowing = false }) {
  return (
    <>
      <div className="listenHistoryTooltip">
        <Avatar src={avatar} size={50} />
        <span className="rapName">{name}</span>
        <span className="lisHisTooltipIcon">
          <FontAwesomeIcon icon={faUserGroup} /> {followers}
        </span>
        <span>
          <FollowButton isFollowing={isFollowing} />
        </span>
      </div>
    </>
  );
}

export default ToolTipTitle;
